import * as React from "react";
import { RadiosEditor } from "../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../react-core/Html/SelectEditor";
import { DistributionDividendPreference } from "../../../../Wrap/Constants/Enums/Domain/DistributionDividendPreference";
import { SectionHeader } from "../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { IProcessComponentProps, ProcessComponent } from "../../Process/Process/ProcessComponent";
import { distributionDividendPreferenceMap, distributionOptionSubHeader, ProcessType } from "../Resource/Content";
import { PaymentType } from "../../../Dashboard/Components/Clients/Common/Resource/Contents";
import { NewBankAccountInstruction } from "../../../Dashboard/Components/Clients/Common/PaymentsIn/BankAccount/NewBankAccountInstruction";
import { BankAccountIdType } from "../../../../Wrap/Constants/Enums/Domain/BankAccountIdType";
import { SubAccountTypeHelper } from "../../../Dashboard/Components/Clients/Common/Helpers/SubAccountTypeHelper";
import { SubAccountType } from "../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { BankAccountAction } from "../../../Dashboard/Components/Clients/Common/PaymentsIn/BankAccount/BankAccountAction";
import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../Permission/PermissionHelper";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { getQueryParameters } from "../../Wizards/Entities/QueryParametersHelper";

interface IDistributionOptionProps extends IProcessComponentProps {
    type: ProcessType;
    product: SubAccountType;
    bankAccounts: any[];
    clAccountId: string;
    ownerId: string;
    onBankChange: (bank) => void;
}

interface IDistributionOptionState {
    isAddingNewBank: boolean;
}

export class DistributionOption extends ProcessComponent<IDistributionOptionProps, IDistributionOptionState> {
    hypotheticalProcessTypes = [ProcessType.Quote, ProcessType.WhatIf, ProcessType.NoChange];

    constructor(props: IDistributionOptionProps) {
        super(props);
        this.state = {
            isAddingNewBank: false,
        };
    }

    isValid() {
        const hasBankAccount =
            this.props.data?.BankAccountId != null ||
            this.props.data?.DistributionDividendPreference !== DistributionDividendPreference.BankAccount;
        if (!hasBankAccount && !this.hypotheticalProcessTypes.includes(this.props.type)) {
            const msg = ["You must add/select a bank account."];
            this.props.showErrorMsgPopUp(msg);
            return false;
        }
        return super.isValid();
    }
    componentDidMount() {
        super.componentDidMount();
        if (!this.props.data?.DistributionDividendPreference)
            {this.props.onChange({ DistributionDividendPreference: DistributionDividendPreference.ProductCash });}
    }

    private saveBankAccountInstrument(bankAccount) {
        bankAccount.OwnerHierarchyId = this.props.ownerId;
        BankAccountAction.saveBankInstruction(bankAccount, null, null, (bankAccountInstruction) => {
            this.props.onBankChange(bankAccountInstruction);
        });
    }

    render() {
        const { onChange, data, bankAccounts } = this.props;

        return (
            <>
                {SectionHeader("Distribution options")}
                <RadiosEditor
                    cssWrapper="control-size-430 mb-30 rg-inline rg-vertical"
                    selected={data?.DistributionDividendPreference}
                    options={Object.keys(distributionDividendPreferenceMap).map((ele) => Number(ele))}
                    onChange={(v) => onChange({ DistributionDividendPreference: v })}
                    required={"Please select"}
                    getText={(v) => {
                        if (v == DistributionDividendPreference.ProductCash) {
                            return `Leave as cash in ${SubAccountTypeHelper.isIsa(this.props.product) ? "ISA" : "PP"}`;
                        }
                        return distributionDividendPreferenceMap[v];
                    }}
                    label={distributionOptionSubHeader}
                />
                {this.props.clAccountId &&
                    !CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"]) &&
                    checkPermission(UserClaim.AdviserPortalDluManageIncomeCanView) && (
                        <div>
                            <a
                                href={"/clients/cash/manageincome.aspx?claccountid=" + this.props.clAccountId}
                                target="_blank"
                            >
                                Change distribution options
                            </a>
                        </div>
                    )}
                {data?.DistributionDividendPreference !== DistributionDividendPreference.BankAccount ||
                this.hypotheticalProcessTypes.includes(this.props.type) ? null : bankAccounts &&
                  bankAccounts.length > 0 ? (
                    <SelectEditor
                        cssWrapper="control-size-430 mb-30 rg-inline"
                        options={bankAccounts}
                        getText={(o) => o.AccountNumber}
                        onChange={(v) =>
                            onChange({
                                BankAccountId: v.BankAccountId || v.Id,
                                BankAccountIdType: v.Id
                                    ? BankAccountIdType.BankAccountInstruction
                                    : BankAccountIdType.BankAccount,
                            })
                        }
                        placeholder="Please select"
                        selected={
                            data?.BankAccountId
                                ? bankAccounts.find(
                                      (ele) => ele.Id == data?.BankAccountId || ele.BankAccountId == data?.BankAccountId
                                  )
                                : null
                        }
                        label="Select a bank account"
                        required="Please select"
                    />
                ) : !this.state.isAddingNewBank ? (
                    <button className="btn secondary" onClick={() => this.setState({ isAddingNewBank: true })}>
                        Add new bank account
                    </button>
                ) : (
                    <NewBankAccountInstruction
                        payeeType={PaymentType.Client}
                        data={data?.BankDetail}
                        onRef={(ref) => this.appendChild(ref)}
                        onChange={(changes) => this.saveBankAccountInstrument(changes)}
                    />
                )}
            </>
        );
    }
}
